
import { useMemo } from 'react';
import { useMode } from '../ModeContext';
import { TAB_DEFINITIONS, TabDefinition } from '../data/mode.constants';
import { useAuth } from '@/context/AuthContext';

export function useModeAware() {
  const { isQuickMode, isAdvancedMode, state } = useMode();
  const { isAdmin } = useAuth();

  const availableTabs = useMemo<TabDefinition[]>(() => {
    const base = isQuickMode
      ? TAB_DEFINITIONS.filter(t => t.quickModeVisible)
      : TAB_DEFINITIONS;
    return base.filter(t => !t.adminOnly || isAdmin);
  }, [isQuickMode, isAdmin]);

  const isTabAvailable = (tabId: string): boolean => {
    return availableTabs.some(t => t.id === tabId);
  };

  const getDefaultTab = (): string => {
    if (isQuickMode) {
      return 'studio';
    }
    return state.lastAdvancedTab || 'studio';
  };

  return {
    isQuickMode,
    isAdvancedMode,
    availableTabs,
    isTabAvailable,
    getDefaultTab,
    quickConfig: state.quickModeConfig,
  };
}
